// BL-177 Step 2g (item 4): is this page running as an installed app (Safari "Add to Dock", Add to Home Screen, an installed
// Chrome app) rather than in a browser tab? An installed app has no address bar, so "open the site's browser settings (the
// icon beside the address)" is wrong there: the permission lives in the system's Notifications settings for that app.

export function isInstalledApp(win = globalThis.window) {
    if (!win) return false;
    try {
        if (win.navigator && win.navigator.standalone === true) return true;
        if (typeof win.matchMedia === 'function') {
            return ['standalone', 'window-controls-overlay', 'minimal-ui'].some((mode) => win.matchMedia(`(display-mode: ${mode})`).matches);
        }
    } catch (failure) {
        return false;
    }
    return false;
}

export function devicePlatform(win = globalThis.window) {
    const nav = (win && win.navigator) || {};
    const agent = String(nav.userAgent || '');
    if (/iPhone|iPad|iPod/i.test(agent) || (/Macintosh/i.test(agent) && Number(nav.maxTouchPoints) > 1)) return 'ios';
    if (/Macintosh|Mac OS X/i.test(agent)) return 'mac';
    if (/Windows/i.test(agent)) return 'windows';
    if (/Android/i.test(agent)) return 'android';
    return 'other';
}

/** The installed app's name as the person sees it (the Dock / Home Screen name). */
export function installedAppName(doc = globalThis.document) {
    const meta = doc && doc.querySelector ? doc.querySelector('meta[name="apple-mobile-web-app-title"]') : null;
    const name = meta && typeof meta.content === 'string' ? meta.content.trim() : '';
    return name || (doc && doc.title ? String(doc.title).split(/[·|–-]/)[0].trim() : '') || 'this app';
}

/** What to do when notifications are blocked. `host` is the address the app was added from (e.g. app.therideatl.com). */
export function blockedGuidance({ installed, platform, appName, host }) {
    if (!installed) {
        return 'Open this site\'s browser settings (the icon beside the address), allow Notifications, then return here. On iPhone, check Settings > Notifications for the installed app.';
    }
    if (platform === 'ios') {
        return `Open the Settings app on your iPhone, choose Notifications, then ${appName}, and turn on Allow Notifications. Then come back here.`;
    }
    if (platform === 'mac') {
        return `This is an installed app, so there is no address bar. On your Mac: open System Settings > Notifications > ${appName} and choose Allow. Then open Safari > Settings > Websites > Notifications, find ${host || 'this site'} and set it to Allow. If this still says blocked, remove ${appName} from the Dock and add it again from Safari (File > Add to Dock).`;
    }
    return `This is an installed app, so there is no address bar. Open your device's Notifications settings, find ${appName}, and allow notifications. Then come back here.`;
}
